import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaCode, FaMobileAlt, FaDesktop, FaShieldAlt, FaUsers, FaAward } from 'react-icons/fa';
import SEO from '../components/SEO';

const AboutUs = () => {
  return (
    <>
      <SEO 
        title="About Us - IT World"
        description="Learn about IT World - Your trusted partner for software solutions, development services, and genuine software licenses."
      />
      <div className="bg-primary text-white py-5">
        <Container>
          <h1 className="text-center mb-3">About IT World</h1>
          <p className="text-center lead">Your Trusted Partner for Software Solutions</p>
        </Container>
      </div>

      <Container className="py-5">
        {/* Company Overview */}
        <Row className="mb-5">
          <Col lg={8} className="mx-auto">
            <h2 className="mb-4">Who We Are</h2>
            <p>
              <strong>IT World</strong> is a leading software solutions provider based in India. 
              We specialize in full-stack development, mobile applications, desktop software, 
              and providing genuine software licenses at competitive prices.
            </p>
            <p>
              Our mission is to empower businesses and individuals with cutting-edge technology 
              solutions while ensuring quality, reliability, and exceptional customer service.
            </p>
            <p>
              With years of experience in the IT industry, we have successfully delivered 
              numerous projects and served thousands of satisfied customers across the globe.
            </p>
          </Col>
        </Row>

        {/* Services */}
        <h2 className="text-center mb-4">Our Services</h2>
        <Row className="mb-5">
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body>
                <FaCode size={48} className="text-primary mb-3" />
                <Card.Title>Web Development</Card.Title>
                <Card.Text>
                  Custom web applications, e-commerce solutions, and responsive websites 
                  using modern technologies.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body>
                <FaMobileAlt size={48} className="text-primary mb-3" />
                <Card.Title>Mobile Apps</Card.Title>
                <Card.Text>
                  Native and cross-platform mobile applications for iOS and Android 
                  devices.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body>
                <FaDesktop size={48} className="text-primary mb-3" />
                <Card.Title>Software Licenses</Card.Title>
                <Card.Text>
                  Genuine software licenses for operating systems, productivity tools, 
                  antivirus, and more.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Why Choose Us */}
        <h2 className="text-center mb-4">Why Choose Us</h2>
        <Row className="mb-5">
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body>
                <FaShieldAlt size={48} className="text-success mb-3" />
                <Card.Title>100% Genuine Products</Card.Title>
                <Card.Text>
                  All our software licenses are authentic and sourced directly from 
                  authorized distributors.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body>
                <FaUsers size={48} className="text-success mb-3" />
                <Card.Title>Dedicated Support</Card.Title>
                <Card.Text>
                  Our customer support team is available to assist you with any 
                  queries or technical issues.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body>
                <FaAward size={48} className="text-success mb-3" />
                <Card.Title>Best Prices</Card.Title>
                <Card.Text>
                  We offer competitive pricing without compromising on quality 
                  or authenticity.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Company Details */}
        <Row>
          <Col lg={8} className="mx-auto">
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                <h3 className="mb-4">Company Information</h3>
                <p><strong>Business Name:</strong> IT World</p>
                <p><strong>Website:</strong> www.accountssuitpro.com</p>
                <p><strong>Email:</strong> itworldwani@gmail.com</p>
                <p><strong>Phone:</strong> +91 9561306384</p>
                <p><strong>Business Hours:</strong> Monday - Saturday, 11:00 AM - 7:00 PM IST</p>
                <p className="mb-0"><strong>Location:</strong> India</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AboutUs;
